import { render, staticRenderFns } from "./RFPBOQQNA.vue?vue&type=template&id=4238242b"
import script from "./RFPBOQQNA.vue?vue&type=script&lang=js"
export * from "./RFPBOQQNA.vue?vue&type=script&lang=js"
import style0 from "./RFPBOQQNA.vue?vue&type=style&index=0&id=4238242b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports